(function(){
  'use strict';

  /* Portalling the long-description modal to <body> prevents transformed/content-
     visibility ancestors from redefining the containing block of position:fixed. */
  document.addEventListener('click',function(event){
    var open=event.target && event.target.closest ? event.target.closest('[data-lbx-story-readmore-open]') : null;
    if(!open)return;
    var story=open.closest('.lbx-story-v9');
    var modal=story && story.querySelector('[data-lbx-story-modal]');
    if(!modal || modal.dataset.lbx98Portaled==='1')return;
    modal.dataset.lbx98Portaled='1';
    requestAnimationFrame(function(){
      if(modal.parentNode!==document.body)document.body.appendChild(modal);
    });
  },false);
})();
